import { UIActionType, UIAction } from '../../actions/uiActions';

const organizationDialogReducer = (state = false, action: UIAction) => {
  switch (action.type) {
    case UIActionType.TOGGLE_ORGANIZATION_DIALOG:
      return !state;
    default:
      return state;
  }
};

export default organizationDialogReducer;
